import { APIClass, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api-graphql/src/types";
import { ModelSortDirection, Transaction } from "../API";
import { listTransactionsByBalanceAccountSortedByOrder } from "../graphql/queries";
import { transactionApiToModel } from "./Transaction";
import { TransactionEntity } from "@goodfill/domain-entities";
import { BalanceAccountId } from "@goodfill/domain-properties";

export interface ListTransactionsByBalanceAccountSortedByOrderData {
  listTransactionsByBalanceAccountSortedByOrder: { items: Transaction[] };
}

export async function doListTransactionsByBalanceAccountSortedByOrder(
  graphqlApi: Pick<APIClass, "graphql">,
  balanceAccountId: BalanceAccountId,
  limit: number | null = 1,
  sortDirection: ModelSortDirection = ModelSortDirection.DESC
): Promise<TransactionEntity[]> {
  const operation = graphqlOperation(
    listTransactionsByBalanceAccountSortedByOrder,
    {
      balanceAccountId: balanceAccountId,
      limit,
      sortDirection,
    }
  );
  const result = (await graphqlApi.graphql(
    operation
  )) as GraphQLResult<ListTransactionsByBalanceAccountSortedByOrderData>;

  if (result.data === undefined) {
    throw new Error("Data undefined");
  }

  return result.data.listTransactionsByBalanceAccountSortedByOrder.items.map(
    transactionApiToModel
  );
}
